import type { SummaryInput } from '@creanizer/types'

export function validateInput(input: SummaryInput): boolean {
  switch (input.inputType) {
    case 'text':
      return !!(input.text && input.text.trim().length > 0)
    case 'file':
      return !!(input.fileContent && input.fileContent.trim().length > 0)
    case 'scene':
      return !!input.sceneId
    case 'plot':
      return !!input.plotId
    default:
      return false
  }
}

export function getInputText(input: SummaryInput): string {
  switch (input.inputType) {
    case 'text':
      return input.text || ''
    case 'file':
      return input.fileContent || ''
    default:
      return ''
  }
}

export function calculateCompressionRatio(originalLength: number, summaryLength: number): number {
  if (originalLength === 0) return 0
  return Math.round((summaryLength / originalLength) * 100)
}